import React from 'react';
import ActionsCellTemplate from '../../components/SettingsTable/components/ActionsCellTemplate';
import ActiveCellTemplate from '../../components/SettingsTable/components/ActiveCellTemplate';
import TextCellTemplate from '../../components/SettingsTable/components/TextCellTemplate';
import { SchemaBuilder } from '../../components/SettingsTable/types';
import { DocumentTypeCell } from './components/DocumentTypeCell';
// import RolesCoverageCellTemplate from './components/RolesCoverageCellTemplate';
import SummaryCellTemplate from './components/SummaryCellTemplate';
import { ApprovalConfigurationSchemaOptions, EditableApprovalConfiguration } from './types';

export const buildSchema: SchemaBuilder<EditableApprovalConfiguration, ApprovalConfigurationSchemaOptions> = ({
  onEdit,
  onDelete,
  disableDelete,
  onActiveStateChange,
  onConfigureClick,
  onConfigureFieldMapping,
  onDocumentTypeUpdated,
  documentTypeList,
  onDiscard,
  onConfirm,
  onCopy,
}) => {
  return [
    {
      id: 'isActive',
      field: 'isActive',
      title: 'common.active',
      width: 80,
      template: (props) => (
        <ActiveCellTemplate
          {...props}
          onActiveStateChange={onActiveStateChange}
        />
      ),
    },
    {
      id: 'configurationName',
      field: 'name',
      title: 'administration.general.settings.approval.configuration.name',
      template: TextCellTemplate,
    },
    {
      id: 'configurationDescription',
      field: 'description',
      title: 'administration.general.settings.approval.configuration.description',
      template: TextCellTemplate,
    },
    {
      id: 'configurationSummary',
      field: 'summary',
      title: 'administration.general.settings.approval.configuration.summary',
      template: (props) => (
        <SummaryCellTemplate {...props} onConfigureClick={onConfigureClick} />
      ),
    },
    {
      id: 'documentTypeIds',
      field: 'documentTypeIds',
      title: 'administration.general.settings.approval.configuration.document.type',
      template: (props) => (
        <DocumentTypeCell {...props} dataOptions={documentTypeList }
          onDocumentTypeUpdated={onDocumentTypeUpdated}
          onConfigureFieldMapping={onConfigureFieldMapping}
        />
      ),
    },
    // {
    //   id: 'roleCoverage',
    //   field: 'roleCoverage',
    //   title: 'administration.general.settings.approval.configuration.role.coverage',
    //   template: (props) => (
    //     <RolesCoverageCellTemplate {...props} />
    //   ),
    // },
    {
      id: 'actions',
      field: 'actions',
      title: 'common.actions',
      width: 75,
      filterable: false,
      template: (props) => (
        <ActionsCellTemplate
          {...props}
          isActive={true}
          onEdit={onEdit}
          onDelete={onDelete}
          onDiscard={onDiscard}
          onConfirm={onConfirm}
          onCopy={onCopy}
          disableDelete={disableDelete}
        />
      ),
    },
  ];
};
